import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';

class CardListAPI extends ComponentAPI implements Clickable {

  /** @event */
  @AwesomeEvent
  onAddNewClick = new ClickEventListener(); // TODO maybe an interface

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  getData(): object[] {
    return this.state.data;
  }

  setData(data: object[]): void {
    if (Array.isArray(data)) {
      this.setState({ data });
    }
  }

  isLoading(): boolean {
    return this.state.loading;
  }

  setLoading(loading: string): void{
    this.setState({ loading });
  }

  getPlaceholderCount(): number {
    return this.state.placeholderCount;
  }

  setPlaceholderCount(placeholderCount: number): void{
    this.setState({ placeholderCount });
  }

  isShowAddNew(): boolean {
    return this.state.showAddNew;
  }

  setShowAddNew(showAddNew: boolean): void{
    this.setState({ showAddNew });
  }

  isShowDates(): boolean {
    return this.state.showDates;
  }

  setShowDates(showDates: boolean): void{
    this.setState({ showDates });
  }

}

export default CardListAPI;
